export const connect_uat = 'https://connect-test.mytcare.ai/'
export const connect_prod = 'https://connect.mytcare.ai/'

export const connectLink = process.env.REACT_APP_ENV === "production" ? connect_prod : connect_uat